"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";


const Titleheading = () => {
    return (
        <div>
            <section className="bg-blue-100 bg-opacity-50 py-8 md:py-12 lg:py-16">
                <div className="max-w-screen-xl mx-5 lg:mx-auto">
                    <div className="grid grid-cols-1 gap-3 items-center justify-between">
                        <div className="">
                            <h1 className="font-bold text-black my-3">VFX & Motion Graphics</h1>
                            <p><a href="/" className="text-neutral-600 hover:text-neutral-800">Home</a> / VFX & Motion Graphics</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Titleheading;